import { useTranslation } from "next-i18next";
import React from "react";

import { useTokenBalance } from "@/features/nft/hooks/useTokenBalance";

import { NFTAccount } from "./NFTAccount";
import { StatisticBlock } from "./StatisticBlock";

type NFTAboutProps = {
  walletAccount?: string;
} & (
  | {
      currentMonthPostCount?: never;
      allNftPostCount?: never;
      showOwned: boolean;
    }
  | {
      currentMonthPostCount: number;
      allNftPostCount: number;
      showOwned?: never;
    }
);
export const NFTAbout: React.FC<NFTAboutProps> = (props) => {
  const { walletAccount, showOwned, currentMonthPostCount, allNftPostCount } =
    props;

  const { t } = useTranslation("profilePublic");
  const { balance } = useTokenBalance({
    skip: !showOwned,
    walletAccount,
  });

  return (
    <>
      <div className="relative flex flex-col w-full border border-solid border-gray-200 rounded-lg">
        {/* Title */}
        <div className="flex flex-col p-4">
          <span className="text-lg  text-gray-900">{t("about")}</span>

          {showOwned ? (
            <div className="w-full flex justify-center items-center">
              <StatisticBlock
                label={t("profilePublic:all")}
                value={walletAccount ? balance : 0}
              />
            </div>
          ) : (
            <div className="grid grid-cols-2 divide-x divide-gray-100 mt-2">
              <StatisticBlock
                label={t("profilePublic:currentMonth")}
                value={currentMonthPostCount}
              />

              <StatisticBlock
                label={t("profilePublic:all")}
                value={allNftPostCount}
              />
            </div>
          )}
        </div>

        {walletAccount && <NFTAccount walletAccount={walletAccount} />}
      </div>
    </>
  );
};
